/**
 * Absolute URL for displaying a user's stored avatar path or full URL.
 */
export function resolveUserAvatarSrc(user, apiBase = '') {
  if (!user?.avatar || typeof user.avatar !== 'string') return null;
  const raw = user.avatar.trim();
  if (!raw) return null;
  if (raw.startsWith('http') || raw.startsWith('//')) return raw;
  const base = String(apiBase || '').replace(/\/$/, '');
  const path = raw.startsWith('/') ? raw : `/${raw}`;
  return `${base}${path}`;
}
